import { toast, ToastOptions } from 'react-toastify';
import { appConstants } from '../shared/constants';

export interface INotifierService {
  error(error?: any, ops?: Partial<ToastOptions>): void;

  info(message: string, ops?: Partial<ToastOptions>): void;

  warn(message: string, ops?: Partial<ToastOptions>): void;
}

export class NotifierService implements INotifierService {
  private options = {
    default: (ops?: Partial<ToastOptions>): ToastOptions => {
      const resultOps: ToastOptions = {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        closeButton: true,
      };
      if (ops) {
        return { ...resultOps, ...ops };
      }
      return resultOps;
    },
  };

  public error(error?: any, ops?: Partial<ToastOptions>): void {
    toast.error(error ?? appConstants.somethingWentWrongErrorMessage, this.options.default(ops));
  }

  public info(message: string, ops?: Partial<ToastOptions>): void {
    toast.info(message, this.options.default(ops));
  }

  public warn(message: string, ops?: Partial<ToastOptions>): void {
    toast.warn(message, this.options.default(ops));
  }
}
